/* Company-template confetti — self-contained, no CDN (CSP-safe), ~2KB.
 * Usage: geroConfetti() or geroConfetti({colors:['#C8A951','#1B3A2C','#F3EFE4']})
 * Fire on: mailing-list subscribe success, bundle add-to-cart, coupon applied.
 * Respects prefers-reduced-motion (no-ops). Auto-cleans its canvas. */
(function (w, d) {
  'use strict';
  if (w.geroConfetti) return;
  w.geroConfetti = function (opts) {
    try {
      if (w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      opts = opts || {};
      var colors = opts.colors || ['#C8A951', '#E8D48A', '#FFFFFF', '#1B3A2C'];
      var count = Math.min(opts.count || 160, 300);
      var cv = d.createElement('canvas');
      cv.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483647';
      var dpr = Math.min(w.devicePixelRatio || 1, 2);
      cv.width = w.innerWidth * dpr; cv.height = w.innerHeight * dpr;
      d.body.appendChild(cv);
      var ctx = cv.getContext('2d'); ctx.scale(dpr, dpr);
      var W = w.innerWidth, H = w.innerHeight, parts = [], i;
      for (i = 0; i < count; i++) {
        var ang = -Math.PI / 2 + (Math.random() - 0.5) * 1.2;
        var v = 7 + Math.random() * 9;
        parts.push({
          x: W / 2 + (Math.random() - 0.5) * W * 0.35,
          y: H * 0.62,
          vx: Math.cos(ang) * v * (0.6 + Math.random()),
          vy: Math.sin(ang) * v * (0.9 + Math.random() * 0.6),
          s: 4 + Math.random() * 5,
          c: colors[(Math.random() * colors.length) | 0],
          r: Math.random() * Math.PI,
          vr: (Math.random() - 0.5) * 0.3,
          life: 110 + Math.random() * 50
        });
      }
      var t0 = null;
      function frame() {
        ctx.clearRect(0, 0, W, H);
        var alive = 0;
        for (var j = 0; j < parts.length; j++) {
          var p = parts[j];
          if (p.life <= 0) continue;
          alive++;
          p.life--; p.x += p.vx; p.y += p.vy; p.vy += 0.22; p.vx *= 0.992; p.r += p.vr;
          ctx.save();
          ctx.globalAlpha = Math.max(0, Math.min(1, p.life / 40));
          ctx.translate(p.x, p.y); ctx.rotate(p.r);
          ctx.fillStyle = p.c;
          ctx.fillRect(-p.s / 2, -p.s / 4, p.s, p.s / 2);
          ctx.restore();
        }
        if (alive > 0) { w.requestAnimationFrame(frame); }
        else { cv.remove(); }
      }
      w.requestAnimationFrame(frame);
    } catch (e) { /* decorative only — never break the page */ }
  };
})(window, document);
